import React, { useState } from 'react';
import {
  MDBNavbar,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBNavbarToggler,
  MDBContainer,
  MDBIcon,
  MDBCollapse,
  MDBBtn,
  MDBNavbarBrand
} from 'mdb-react-ui-kit';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './language-switcher';

export default function Header() {
  const [showBasic, setShowBasic] = useState(false);
  const { t } = useTranslation();

  const handleLinkClick = () => {
    if (showBasic) {
      setShowBasic(false);
    }
  };

  return (
    <header>
      <MDBNavbar expand='lg' light bgColor='white' fixed='top'>
        <MDBContainer fluid>
          <MDBNavbarBrand href='/' className='d-flex align-items-center'>
            <span style={{ fontWeight: '300' }}>LETTER</span>
            <span style={{ fontWeight: '600', marginLeft: '8px' }}>EXECUTIVA</span>
            <span style={{ fontWeight: '300', marginLeft: '8px' }}>ONE</span>
          </MDBNavbarBrand>
          <MDBNavbarToggler
            type='button'
            aria-expanded='false'
            aria-label='Toggle navigation'
            onClick={() => setShowBasic(!showBasic)}
          >
            <MDBIcon icon='bars' fas />
          </MDBNavbarToggler>

          {/* @ts-ignore */}
          <MDBCollapse navbar open={showBasic}>
            <MDBNavbarNav className='ms-auto mb-2 mb-lg-0 text-center'>
              <MDBNavbarItem>
                <Link to="/" onClick={handleLinkClick}>
                  <MDBNavbarLink active={window.location.pathname === '/'}>
                    {t('nav.home')}
                  </MDBNavbarLink>
                </Link>
              </MDBNavbarItem>
              <MDBNavbarItem>
                <Link to="/contact" onClick={handleLinkClick}>
                  <MDBNavbarLink active={window.location.pathname === '/contact'}>
                    {t('nav.contact')}
                  </MDBNavbarLink>
                </Link>
              </MDBNavbarItem>
              <MDBNavbarItem className="d-flex justify-content-center">
                <LanguageSwitcher />
              </MDBNavbarItem>
            </MDBNavbarNav>
          </MDBCollapse>
        </MDBContainer>
      </MDBNavbar>

      <div
        className='p-5 text-center bg-image'
        style={{ 
          backgroundImage: "url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=2072&q=80')",
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          height: '400px',
          marginTop: '58px'
        }}
      >
        <div className='mask' style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}>
          <div className='d-flex justify-content-center align-items-center h-100'>
            <div className='text-white'>
              <h1 className='mb-3'>{t('header.title')}</h1>
              <h4 className='mb-3'>{t('header.subtitle')}</h4>
              <Link to="/contact" onClick={handleLinkClick}>
                <MDBBtn tag="a" outline size="lg">
                  {t('header.contact')}
                </MDBBtn>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}